import { render, staticRenderFns } from "./Pavilions.vue?vue&type=template&id=54e245cc&scoped=true"
import script from "./Pavilions.vue?vue&type=script&lang=ts"
export * from "./Pavilions.vue?vue&type=script&lang=ts"
import style0 from "./Pavilions.vue?vue&type=style&index=0&id=54e245cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e245cc",
  null
  
)

export default component.exports